import { NotFoundComponent } from '@/ui/templates/NotFound/NotFoundComponent';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ShimmerText, ShimmerThumbnail } from 'react-shimmer-components';

type Props = { call?: 'full' | 'partial'; shimmerWidth?: string };

const LoadingShimmer = (props: Props) => {
  const [showShimmer, setShowShimmer] = useState(true);
  const { call, shimmerWidth } = props;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowShimmer(false);
    }, 10000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (showShimmer) {
    return (
      <>
        {call === 'full' && <ShimmerThumbnail height={200} rounded />}
        <ContentShimmer shimmerWidth={shimmerWidth} />
        {call === 'full' && <ShimmerThumbnail height={50} rounded />}
      </>
    );
  } else return <NotFoundComponent />;
};

const ContentShimmer = ({ shimmerWidth }: { shimmerWidth?: string }) => {
  const width = shimmerWidth ? shimmerWidth : '60vw';
  return (
    <>
      <Box style={{ margin: 'auto', width: width, paddingTop: '15' }}>
        <ShimmerText line={38} gap={10} />
      </Box>
    </>
  );
};

export default LoadingShimmer;
